import React from "react";
import "./trafficLightIndicator.css";

const TrafficLightIndicatorEstresPhysical = ({ category, riskLevel, recommendation }) => {
  let textRisk = ""
  // Asignar color según el nivel de riesgo
  const getColor = (level) => {
    switch (level) {
      case 0:
        textRisk = "Sin Estrés"
        return "green";
      case 1:
        textRisk = "Estrés Leve"
        return "yellow";
      case 2:
        textRisk = "Estrés Medio"
        return "yellow";
      case 3:
        textRisk = "Estrés Alto"
        return "red";
      case 4:
        textRisk = "Estrés Grave"
        return "red";
      
      default:
        return "gray";
    }
  };

  return (
    <div className="traffic-light-indicator">
      <h3 className="category-title">{category}</h3>
      <div className={`traffic-light ${getColor(riskLevel)}`}>
        {textRisk}
      </div>
      <p className="recommendation">{recommendation}</p>
    </div>
  );
};

export default TrafficLightIndicatorEstresPhysical;
